import React from "react";
// import React, { useEffect, useState } from "react";
// import Preloader from "../components/Loader";

import Banner from "../components/Common/Banner";
import SectionTitle from "../components/Common/SectionTitle";
// Banner
import AboutBanner from "../assests/bg-about.png";
import { CCol, CContainer, CRow } from "@coreui/react";

import AboutImage1 from "../assests/about-us.jpg";

// Button

import Button from "../components/Common/Button";
import staticData from "../assests/staticData.json";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function About() {
  const { about_page } = staticData;
  return (
    <>
      <Banner
        banner={AboutBanner}
        subtext={"Registered NDIS Provider"}
        text={"about us"}
      />
      {/* About */}

      <section className="about-info-wrapper">
        <CContainer>
          <CRow>
            <CCol lg={6}>
              <div className="about-us-image-wrapper">
                <img src={AboutImage1} alt="about-img" className="img-fluid" />
                <span className="about-image-box"></span>
              </div>
            </CCol>
            <CCol lg={12} className="mt-5">
              <div className="about-info-content">
                {about_page?.about_content_desc.length > 0 &&
                  about_page?.about_content_desc.map((desc, index) => (
                    <p key={index} className="themeGrayPara in-fs lh-28">
                      {desc}
                    </p>
                  ))}

                <CRow className="gx-2">
                  {about_page.service_desc_list.map((list, index) => (
                    <div className="service-desc-list-box" key={index}>
                      <div className="service-desc-icon">
                        <span>
                          <FontAwesomeIcon icon={faCheck} />
                        </span>
                      </div>
                      <div>
                        <p
                          key={index}
                          className="themeGrayPara in-fs lh-28 mb-2"
                        >
                          <b style={{ color: "#0b3d2c" }}>{list?.title}</b> :{" "}
                          {list?.title_desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </CRow>
                {about_page?.about_content_bottom.length > 0 &&
                  about_page?.about_content_bottom.map((desc, index) => (
                    <p key={index} className="themeGrayPara in-fs lh-28">
                      {desc}
                    </p>
                  ))}
                  <div className="text-start">
                  <strong style={{fontSize:"40px",color:"#0b3d2c"}}>ABN</strong>
                  <p style={{fontSize:"40px",color:"#0b3d2c", lineHeight:"40px", fontWeight:"600"}} className="mt-0">11 640 035 463</p>
                </div>
                <div className="mt-4">
                  <Button
                    themeButton={"theme-primary-btn"}
                    buttonText={"get in touch"}
                    buttonLink={"/contact"}
                  />
                </div>
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>

      {/* Our Mission & Value */}
      <section
        className="mession-value-section-wrapper pt-0"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.04)" }}
      >
        <CContainer>
          <CRow className="gx-lg-5">
            <CCol lg={6} className="mb-lg-0 mb-4">
              <div className="mb-4">
                <SectionTitle
                  align={"left"}
                  subTitle={""}
                  subtitle={false}
                  Title={"our mission"}
                />
              </div>
              <div className="mission-content-wrapper">
                {about_page?.our_mission.length > 0 &&
                  about_page?.our_mission.map((desc, index) => (
                    <p key={index} className="themeGrayPara in-fs lh-28">
                      {desc}
                    </p>
                  ))}
              </div>
            </CCol>
            <CCol lg={6}>
              <div>
                <SectionTitle
                  align={"left"}
                  subTitle={""}
                  subtitle={false}
                  Title={"our values"}
                />
              </div>
              <div className="value-content-wrapper">
                <div className="mt-4">
                  <ul>
                    {about_page?.our_value.length > 0 &&
                      about_page?.our_value.map((value) => (
                        <li key={value.id}>
                          <strong>{value.title}</strong> -
                          <span className="mb-0">{value.title_desc}</span>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
